module.exports = __webpack_public_path__ + "static/img/timelinered.7caa248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/timelinered.png
// module id = K8yM
// module chunks = 0